module.exports = __webpack_public_path__ + "fonts/MiSans-Regular.77d5caaf.ttf";